<template>
  <div class="po-f w100 h100 set-use-app" v-show="isShow">
    <div class="po-f bg-ww set-use-app-wrapper" v-loading="loading">
      <div class="po-r pt10 font-18 blue tx-c off">
        添加常用设置
        <i class="fr cu-p mr10 grey myfont icon-guanbi" @click="hideView"></i>
      </div>

      <el-row class="w100 pt20 pl20 pr20 pb10 bor-b">
        <el-col :span="22">
          <SiftComp ref="sift" :sift-data="siftData" :loading="loading" @click-search="fetchList" />
        </el-col>
        <el-col :span="2">
          <el-button class="w100" v-if="siftData.length" type="primary" :loading="searching" @click="fetchList">查询</el-button>
        </el-col>
      </el-row>

      <section class="set-h pb20" v-if="list.length > 0" v-loading="searching">
        <div class="po-r w100 pr20 pl20 pt20 cl-f" v-for="(item, index) in list" :key="index" v-show="item.serveList.length">
          <div class="po-r pl10 font-16 mb10 title">{{ item.label }}</div>
          <div class="po-r fl tx-c pl20 pr20 pt10 pb10 cu-p app-list" :class="val.selfUse ? 'seled' : null" v-for="(val, key) in item.serveList" :key="key" @click="clickSelfUse(val.selfUse, val.id, index, key)">
            <i class="myfont icon-gouxuan grey check-box" v-show="val.selfUse"></i>
            <img :src="!val.serveImage ? baseUrl + 'images/icon-app.png' : val.serveImage" width="60" height="60">
            <p class="mt10 font-14 ellipsis-2">{{ val.serveName }}</p>
          </div>
        </div>
      </section>

      <!-- <div class="w100 mc pt10 pr20 pb10 bor-t tx-r" v-show="total > 0">
        <el-pagination background @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SiftComp from "@/components/CompSift/SiftComp";

export default {
  name: "CardVddl",
  components: {
    SiftComp
  },
  props: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      isShow: false,

      loading: false,
      searchText: "",
      siftData: [],

      searching: false,
      page: 1,
      total: 0,
      size: 99999999,
      list: []
    };
  },
  created() {},
  computed: {
    ...mapState(["userData"])
  },
  mounted() {
    // this.fetchSiftData();
  },
  methods: {
    fetchSiftData() {
      this.loading = true;

      this.$http
        .post("serve/queryCondition", this.$qs.stringify({}))
        .then(({ data }) => {
          if (data.resCode == 0 && data.resStatus == 0) {
            const siftList = data.resData.siftData.map(val => {
              val.type = "select";
              return val;
            });
            this.siftData = [
              {
                label: "名称",
                type: "text",
                key: "serveKey"
              },
              ...siftList
            ];
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;

          this.$nextTick(() => {
            this.fetchList();
          });
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
          this.error = 404;
          this.loading = false;
        });
    },
    fetchList() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }
      obj.userId = this.userData.userId;
      obj.pageNum = this.page;
      obj.pageSize = this.size;
      // console.log(obj);

      this.searching = true;
      this.$http
        .post("serve/query", this.$qs.stringify(obj))
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode) {
            this.list = data.RetData;
            // this.total = data.resData.total;
          } else {
            this.error = 0;
            this.errorMsg = data.resMsg;
          }
          this.searching = false;
        })
        .catch(() => {
          this.error = 404;
          this.searching = false;
        });
    },
    clickSelfUse(isTrue, id, index, key) {
      const URL = !isTrue ? `serveUse/add` : `serveUse/cancel`;
      this.$http
        .post(
          URL,
          this.$qs.stringify({
            userId: this.userData.userId,
            serveCode: id
          })
        )
        .then(({ data }) => {
          if (data.resStatus == 0 && data.resCode == 0) {
            this.list[index].serveList[key].selfUse = !isTrue;
            this.$message({
              message: data.resMsg,
              type: "success"
            });
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "操作失败，请检查网络",
            type: "error"
          });
        });
    },
    showView() {
      this.isShow = true;
      this.fetchSiftData();
    },
    hideView() {
      this.isShow = false;
      this.$emit("hide-view");
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    }
  }
};
</script>

<style scoped>
.set-use-app {
  left: 0;
  top: 0;
  z-index: 2001;
  background: rgba(0, 0, 0, 0.5);
}

.set-use-app-wrapper {
  top: 10%;
  left: 10%;
  width: 80%;
  height: 80%;
  overflow: hidden;
  border-radius: 12px;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}

.off {
  height: 40px;
  line-height: 40px;
}

.off .icon-guanbi {
  font-size: 24px;
}

.off .icon-guanbi:hover {
  color: #333;
}

.title::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0.2em;
  width: 4px;
  height: 1em;
  background: #475eb7;
  border-radius: 2px;
}

.set-h {
  /* height: calc(100% - 160px); */
  flex: 1;
  overflow-y: auto;
}

.app-list {
  width: 14%;
  height: 140px;
  margin: 0 1% 10px 1%;
}

.app-list:hover,
.app-list.seled {
  border-radius: 4px;
  background: #eee;
}

.check-box {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>